export const es_translation =
{
  'zuora': {
    'title': 'Método De Pago',
    'CC-label': 'Pague con seguridad usando su tarjeta de crédito. Por favor, introduzca la información de su tarjeta de crédito para proceder.',
    'button': 'Continuar con la revisión',
    // tslint:disable-next-line:max-line-length
    'error': '​El servidor ha encontrado un error temporal al intentar completar su solicitud.  Por favor, confirme que la información introducida es correcta.  Si continúa viendo este mensaje, cierre la aplicación e inténtelo de nuevo.​​',
    'tmna': {
      'consent-cc-one': 'N/A',
      'consent-cc-two': '',
      'consent-cc-three': '',
      'consent-cc-four': ''
    },
    'tdpr': {
      'consent-cc-one': 'Marcar este encasillado autoriza los cargos programados a la tarjeta de crédito proporcionada, según se describe en lo ',
      'consent-cc-two': 'Términos de Uso',
      'consent-cc-three': ', incluida la política de reembolso.',
      'consent-cc-four': ' Esta tarjeta se convertirá en el método de pago predeterminado.'
    },
    'tci': {
      'consent-cc-one': 'N/A',
      'consent-cc-two': '',
      'consent-cc-three': '',
      'consent-cc-four': ''
    }
  }
}
